import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { DashboardVerificationTransactionsResponse } from "@idw-types/data/dashboard";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

export const getDashboardVerificationTransactionsRequest = async (
    companyId: string,
    timeZone: string,
): Promise<GenericNetworkResponse<DashboardVerificationTransactionsResponse>> => {
    const route = apiRoutes.reports.dashboard.verificationTransactions;
    const queryParameters: Array<QueryParameter> = [];

    if (companyId) {
        queryParameters.push({ parameter: "companyIDs", value: companyId });
    }
    if (timeZone) {
        queryParameters.push({ parameter: "timeZone", value: timeZone });
    }

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};